module.exports = __webpack_public_path__ + "img/sc-3p-2022.0a18f7a9.png";